/* eslint-disable react/prop-types */
import React from 'react';

import TextView from '../../view/TextView/TextView';

import './TextExplorer.less';

function TextExplorer({listContent, callBackSelectedList, isFullView}) {
  return (
    <div className="textExplorerMain">
      <TextView
        textList={listContent}
        callBackSelectedList={callBackSelectedList}
        isFullView={isFullView}
      />
    </div>
  );
}

export default TextExplorer;
